import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { ModalSolicitacaoComponent } from '../../modal-solicitacao/modal-solicitacao.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PontosCriticosAgregadorIndicadorService } from '../../services/pontos-criticos-agregador-indicador.service';
import { PontosCriticosProjetoEntregaService } from '../../services/pontos-criticos-projeto-entrega.service';
import { PontosCriticosProjetoIndicadorService } from '../../services/pontos-criticos-projeto-indicador.service';
import { PontosCriticosProjetoService } from '../../services/pontos-criticos-projeto.service';

@Component({
  selector: 'app-detalhe-projeto-pontos-criticos-list',
  templateUrl: './detalhe-projeto-pontos-criticos-list.component.html',
  styleUrls: ['./detalhe-projeto-pontos-criticos-list.component.scss']
})
export class DetalheProjetoPontosCriticosListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {

  @Input() idIndicador: number;
  @Input() idPgIndicador: number;
  @Input() idEntrega: number;
  @Input() pgType: string;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  canCreate: boolean;
  lista: any[];
  filtroOrigem: string = 'todos';
  superados: boolean = false;
  excluidos: boolean = false;
  servico_temp: any;
  showSituacao: any = {};

  types = [
    { id: 'todos', label: 'Todos' },
    { id: 'projeto', label: 'Projeto' },
    { id: 'entregavel', label: 'Entregas' },
    { id: 'indicador', label: 'Indicadores' },
  ];

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;
  @ViewChild("modalSolicitacao") modalSolicitacao: ModalSolicitacaoComponent;

  constructor(
    private myService: PontosCriticosProjetoService,
    private pcEntregaService: PontosCriticosProjetoEntregaService,
    private pcIndicadorService: PontosCriticosProjetoIndicadorService,
    private pcAgregadorIndicadorService: PontosCriticosAgregadorIndicadorService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.canCreate = false;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    if (this.idIndicador) {
      this.addSub(
        this.myService.indicadorList(this.idIndicador).subscribe((res) => {
          this.lista = res['lista'];
          this.canCreate = res['canCreate'];
          this.loaded();
        })
      );
    } else if (this.idEntrega) {
      this.addSub(
        this.myService.entregaList(this.idEntrega).subscribe((res) => {
          this.lista = res['lista'];
          this.canCreate = res['canCreate'];
          this.loaded();
        })
      );
    } else if (this.idPgIndicador) {
      this.addSub(
        this.myService.agregadorIndicadorList(this.idPgIndicador).subscribe((res) => {
          this.lista = res['lista'];
          this.canCreate = res['canCreate'];
          this.loaded();
        })
      );
    } else {
      this.addSub(
        this.myService.getListAll(this.idProjeto).subscribe((res) => {
          this.lista = res['lista'];
          this.canCreate = res['canCreate'];
          this.loaded();
        })
      );
    }
  }

  mostrarSuperados() {
    this.superados = !this.superados;
  }

  mostrarExcluidos() {
    this.excluidos = !this.excluidos;
  }

  novo() {
    if (this.idIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', 'adicionar'];
    } else if (this.idEntrega) {
      return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', 'adicionar'];
    } else if (this.idPgIndicador) {
      return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', 'adicionar'];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'adicionar'];
    }
  }

  editarClickHandler(data: any) {
    if (data.baseRoute == 'projeto') {
      return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', data.id];
    } else if (data.baseRoute == 'entregavel') {
      if (this.idEntrega) { // navegação a partir da aba de entregas
        return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', data.id];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', data.id];
      }
    } else if (data.baseRoute == 'agregador-indicador') {
      return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', data.id];
    } else {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
        return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', data.id];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', data.id];
      }
    }
  }

  deleteClickHandler(data: any): void {
    this.alertConfirmation(data).subscribe((confirmed) => {
      if (confirmed) {
        this.loading();

        if (data.baseRoute == 'entregavel') {
          this.servico_temp = this.pcEntregaService;
        } else if (data.baseRoute == 'indicador') {
          this.servico_temp = this.pcIndicadorService;
        } else if (data.baseRoute == 'agregador-indicador') {
          this.servico_temp = this.pcAgregadorIndicadorService;
        } else {
          this.servico_temp = this.myService;
        }

        this.servico_temp.delete(data.id).subscribe({
          next: (res) => {
            // this.decreasePontosCriticosItens();
            this.initLoadDataTable();
            this.msgSuccess();
          },
          error: (error) => {
            this.loaded();
            this.msgError(error?.error?.message);
          },
        });
      }
    });

  }

  novaDemandaLink() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(tipo: string, data: any, base_route: string) {
    let queryParamsKey = '';
    const queryParamMap = {
      'pc': { // nova demanda a partir de um ponto critico
        'projeto': 'pf_critical_id',
        'entregavel': 'pf_prt_issue_critical_id',
        'indicador': 'pf_ind_critical_id'
      },
      'pa': { // nova demanda a partir de um plano de ação
        'projeto': 'pf_action_id',
        'entregavel': 'pf_prt_issue_action_id',
        'indicador': 'pf_ind_action_id'
      }
    };

    queryParamsKey = queryParamMap[tipo || 'default'][base_route];
    return { [queryParamsKey]: data.id }
  }

  novaAcaoClickHandler(data: any) {
    if (data.baseRoute == 'projeto') {
       return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', data.id, 'plano-acao', 'adicionar'];
    } else if (data.baseRoute == 'indicador') {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
         return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', data.id, 'plano-acao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', data.id, 'plano-acao', 'adicionar'];
      }
    } else if (data.baseRoute == 'entregavel') {
      if (this.idEntrega) { // navegação a partir da aba de entregas
         return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', data.id, 'plano-acao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', data.id, 'plano-acao', 'adicionar'];
      }
    } else if (data.baseRoute == 'agregador-indicador') {
       return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', data.id, 'plano-acao', 'adicionar'];
    }
  }

  novaSituacaoClickHandler(data: any, ponto_critico_id: number, base_route: string) {
    if (base_route == 'projeto') {
       return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', ponto_critico_id, 'plano-acao', data.id, 'situacao', 'adicionar'];
    } else if (base_route == 'indicador') {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
         return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', ponto_critico_id, 'plano-acao',  data.id, 'situacao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', ponto_critico_id, 'plano-acao', data.id, 'situacao', 'adicionar'];
      }
    } else if (base_route == 'entregavel') {
      if (this.idEntrega) { // navegação a partir da aba de entregas
         return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', ponto_critico_id, 'plano-acao',  data.id, 'situacao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', ponto_critico_id, 'plano-acao', data.id, 'situacao', 'adicionar'];
      }
    } else if (base_route == 'agregador-indicador') {
       return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', ponto_critico_id, 'plano-acao', data.id, 'situacao', 'adicionar'];
    }
  }

  editarAcaoClickHandler(data: any, ponto_critico_id: number, base_route: string) {
    if (base_route == 'projeto') {
       return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', ponto_critico_id, 'plano-acao', data.id];
    } else if (base_route == 'indicador') {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
         return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', ponto_critico_id, 'plano-acao',  data.id];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', ponto_critico_id, 'plano-acao', data.id];
      }
    } else if (base_route == 'entregavel') {
      if (this.idEntrega) { // navegação a partir da aba de entregas
         return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', ponto_critico_id, 'plano-acao',  data.id];
      } else { // navegação a partir da aba de pontos criticos
         return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', ponto_critico_id, 'plano-acao', data.id];
      }
    } else if (base_route == 'agregador-indicador') {
       return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', ponto_critico_id, 'plano-acao', data.id];
    }
  }

  verSituacaoClickHandler(data: any): void {
    if (this.showSituacao[data.id]) {
      this.showSituacao[data.id] = !this.showSituacao[data.id];
    } else {
      this.showSituacao[data.id] = true;
    }
  }

  solicitarNovaSituacaoClickHandler(data: any) {
    this.loading();

    if (data.baseRoute == 'entregavel') {
      this.servico_temp = this.pcEntregaService;
    } else if (data.baseRoute == 'indicador') {
      this.servico_temp = this.pcIndicadorService;
    } else if (data.baseRoute == 'agregador-indicador') {
      this.servico_temp = this.pcAgregadorIndicadorService;
    } else {
      this.servico_temp = this.myService;
    }

    this.addSub(
      this.servico_temp.solicitarNovaSituacao(data.id).subscribe({
        next: (res) => {
          this.msgSuccess("Solicitação enviada com Sucesso!");
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    );
  }

  viewResonsavel(item) {
    this.modalResonsavel.openModal([item]);
  }

  viewSolicitacao(item) {
    this.modalSolicitacao.openModal(item);
  }

}
